import map from "lodash/fp/map";
import find from "lodash/fp/find";
import join from "lodash/fp/join";
import sortBy from "lodash/fp/sortBy";
import isNull from "lodash/fp/isNull";
import reverse from "lodash/fp/reverse";
import isObject from "lodash/fp/isObject";
import moment from "moment";

class Controller {
  constructor($injector, $timeout, $state, $mdSidenav, Sections) {
    "ngInject";

    this.$timeout = $timeout;
    this.$mdSidenav = $mdSidenav;
    this.$state = $state;
    this.Events = $injector.get("Events");
    this.Lists = $injector.get("Lists");
    this.sections = Sections.routesSections;
    this.startingDistrict = { name: "" };
    this.destinationDistrict = { name: "" };

    const findByName = (name) => (item) => item.name === name;
    this.Lists = this.Lists.all;
    this.filter = {
      type: "UNSAT",
      time: "AM",
    };
    this.selected = {
      type: find(findByName("UNSAT"))(this.Lists.routeSatisfictionTypes),
      time: find(findByName("AM"))(this.Lists.routeTimingTypes),
    };

    this.filters = [
      {
        title: "Type",
        name: "type",
        icon: "data_usage",
        list: this.Lists.routeSatisfictionTypes,
      },
      {
        title: "Time of Day",
        name: "time",
        icon: "access_time",
        list: this.Lists.routeTimingTypes,
      },
    ];

    this.Rougena = $injector.get("Rougena");

    this.quantity = 0;
    this.total = 0;
    this.limit = 10;
    this.isLoading = false;
    this.isRoutesFetched = false;

    this.onSelectStartingDistrictEvent = this.Events.getSelectStartPointEvent();
    this.onSelectDestinationDistrictEvent = this.Events.getSelectDestinationEvent();
    this.onClickRouteEvent = this.Events.getSelectRouteEvent("routePlaning");
  }

  $onInit() {
    const sortByTimestamp = (item) => item.timestamp;
    const formatSavedStations = (stations) =>
      map((station) => ({
        ...station,
        fromNow: moment.unix(station.timestamp).fromNow(),
      }))(stations);

    const get = () => {
      this.Rougena.suggestPolygons(this.filter).$promise.then(
        (response) => {
          this.suggestedRoutes = response;
          this.total = this.suggestedRoutes.length;
          this.hasMore = this.total > this.limit;
          this.quantity = this.hasMore ? this.limit : this.total;
          if (!this.isRoutesFetched) this.isRoutesFetched = true;
        },
        () => {}
      );

      this.Rougena.getSavedRoutes().$promise.then(
        (response) => {
          const formatedStations = formatSavedStations(response);

          this.savedRoutes = reverse(
            sortBy([sortByTimestamp], formatedStations)
          );
        },
        () => {}
      );
    };

    get();

    const clearFilter = (key) => {
      if (this.filter[key]) delete this.filter[key];
    };

    this.isOpenSaved = () => this.$mdSidenav("saved-routes-sidenav").isOpen();

    this.toggleSavedRoutes = () =>
      this.$mdSidenav("saved-routes-sidenav").toggle();

    this.generateRoute = (route = null) => {
      const from = route ? route.origin.id : this.startingDistrict._id;
      const to = route ? route.destination.id : this.destinationDistrict._id;
      const time = this.filter.time;
      const type = this.filter.type;

      this.toRoute([from, to, time, type]);
    };

    this.toRoute = (query) => {
      this.$state.go("routeedit", { districtsQuery: join(",", query) });
    };

    this.onSelectStartingDistrict = (item) => {
      if (isNull(item)) clearFilter("origin");
      if (item && isObject(item)) {
        this.startingDistrict = item;
        this.filter.origin = this.startingDistrict._id;
      }
      get();
    };

    this.onSelectDestinationDistrict = (item) => {
      if (isNull(item)) clearFilter("destination");
      if (item && isObject(item)) {
        this.destinationDistrict = item;
        this.filter.destination = this.destinationDistrict._id;
      }
      get();
    };

    this.onListSelect = (selected) => {
      this.filter[selected.type] = selected.name;
      get();
    };

    this.fetchMoreLines = () => {
      this.isLoading = true;
      const quantity = this.quantity + this.limit;

      this.hasMore = Boolean(this.total > quantity);
      this.$timeout(() => {
        if (this.hasMore) this.quantity = quantity;
        this.isLoading = false;
      }, 1500);
    };

    this.Events.on(
      this.onSelectStartingDistrictEvent,
      this.onSelectStartingDistrict
    );
    this.Events.on(
      this.onSelectDestinationDistrictEvent,
      this.onSelectDestinationDistrict
    );
    this.Events.on(this.onClickRouteEvent, this.generateRoute);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/routePlanning/routePlanning.controller.js